export const test = ($http: HttpApi) => ({
  create: (params: HttpParams['body']) => $http.$post('/workflow_execution/test', { body: params }),
});
